module.exports = __webpack_public_path__ + "static/royal-college-white-no-text-fdab7a3c85d50050554f16b2dceb472f.svg";